"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
var VaultFileUsageSubjectTypeEnum;
(function (VaultFileUsageSubjectTypeEnum) {
    VaultFileUsageSubjectTypeEnum["MESSAGE_THREAD"] = "message_thread";
})(VaultFileUsageSubjectTypeEnum = exports.VaultFileUsageSubjectTypeEnum || (exports.VaultFileUsageSubjectTypeEnum = {}));
class VaultsProvider extends DataProvider_1.default {
    get fragments() {
        return {
            VaultFile: () => `
        ... on VaultFile {
          id
          userId
          uuid
          urlPart
          contentType
          metadata
          createTime
          lastUseTime
          categoryIds
          caption
          pricePackageId
        }
      `,
            VaultCategory: () => `
        ... on VaultCategory {
          id
          userId
          name
          createTime
          system
          keywords
          ai
        }
      `,
        };
    }
    search({ data }) {
        return this.query("vaultFilesSearch", { data }, this.getPageableFragment("VaultFile"));
    }
    getUploadUrls(count) {
        return this.query("vaultFilesUploadUrls", { count }, this.getFragment("FileUploadResponse"));
    }
    createFile({ data }) {
        return this.mutate("vaultFilesCreate", { data }, this.getFragment("VaultFile"));
    }
    updateFile({ data }) {
        return this.mutate("vaultFilesUpdate", { data }, this.getFragment("VaultFile"));
    }
    deleteFileFromCategory({ data }) {
        return this.mutate("vaultFileDeleteFromCategory", { data });
    }
    searchCategories(userId, fields) {
        return this.query("vaultCategoriesSearch", { userId }, this.getFragment("VaultCategory", fields));
    }
    createCategory({ data }) {
        return this.mutate("vaultCategoryCreate", { data }, this.getFragment("VaultCategory"));
    }
    deleteCategory(id) {
        return this.mutate("vaultCategoryDelete", { id });
    }
    updateCategory({ data }) {
        return this.mutate("vaultCategoryUpdate", { data }, this.getFragment("VaultCategory"));
    }
    vaultFilesMove({ data }) {
        return this.mutate("vaultFilesMove", { data }, this.getFragment("VaultFile"));
    }
    vaultFilesMoveAll({ data }) {
        return this.mutate("vaultFilesMoveAll", { data });
    }
}
exports.VaultsProvider = VaultsProvider;
//# sourceMappingURL=VaultsProvider.js.map